import { Tab } from "@headlessui/react";
import React, { Fragment } from "react";
import {
  getDifferenceInDays,
  getFormattedDateDDMMMYYYYDate,
} from "../../utilities/dateFunctions/formatdate";
import newImg from "../../assets/new.gif";
import { IconContext } from "react-icons";
import { FaFilePdf } from "react-icons/fa";
import { linkTextPrimary } from "../../theme/lightTheme";
import Button from "../buttons/Button";

const HeadlessUITab = ({ tabCategory, onClickView }) => {
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <Tab.Group>
      <Tab.List className="flex p-1 space-x-1 bg-ternary rounded-xl">
        {Object.keys(tabCategory).map((category) => (
          <Tab
            key={category}
            className={({ selected }) =>
              classNames(
                "w-full py-2.5 text-sm leading-5 font-medium rounded-lg",
                "focus:outline-none focus:ring-0 focus:ring-violet-300",
                selected
                  ? "bg-white text-secondary shadow"
                  : "text-slate-600 hover:bg-white/[0.12] hover:text-white"
              )
            }
          >
            {category}
          </Tab>
        ))}
      </Tab.List>
      <Tab.Panels className={"mt-1"}>
        {Object.values(tabCategory).map((posts, idx) => (
          <Tab.Panel
            key={idx}
            className={classNames(
              "p-1",
              "focus:outline-none focus:ring-0 focus:ring-violet-300"
            )}
          >
            <ul>
              {posts.length > 0 &&
                posts.map((post) => (
                  <li
                    key={post.id}
                    className="relative p-3 rounded-md bg-white mb-2 border-b shadow cursor-pointer"
                    onClick={() => onClickView(post.doc, post.title, post.desc)}
                  >
                    <div
                      className={`${
                        post.type !== "News" && post.type !== "Event"
                          ? new Date().setDate(new Date().getDate() - 7) <
                            new Date(post.postedon)
                            ? "absolute"
                            : "hidden"
                          : getDifferenceInDays(
                              new Date(post.endson),
                              new Date(post.postedon)
                            ) > 3
                          ? new Date().setDate(new Date().getDate() - 3) <
                            new Date(post.postedon)
                            ? "absolute"
                            : "hidden"
                          : "hidden"
                      }  -left-1 -top-1 text-xs`}
                    >
                      <img src={newImg} className={"h-3"} />
                    </div>
                    <div className="flex justify-between">
                      <div className="flex flex-col">
                        <h3 className="text-sm font-medium leading-5">
                          {post.title}
                        </h3>

                        <ul className="flex mt-1 space-x-1 text-xs font-normal leading-4 text-coolGray-500">
                          <li className="font-medium text-xs">
                            {getFormattedDateDDMMMYYYYDate(post.postedon)}
                          </li>
                        </ul>
                      </div>
                      {post.doc !== null && post.doc !== "" && (
                        <div className="flex flex-col">
                          <Fragment>
                            <IconContext.Provider
                              value={{
                                className:
                                  "text-red-700 text-5xl cursor-pointer",
                              }}
                            >
                              <FaFilePdf
                                onClick={() =>
                                  onClickView(post.doc, post.title, post.desc)
                                }
                              />
                            </IconContext.Provider>
                          </Fragment>
                        </div>
                      )}
                    </div>
                  </li>
                ))}
              {posts.length === 0 && (
                <li
                  key={1}
                  className="relative p-3 rounded-md bg-white mb-2 border-b shadow"
                >
                  <h3 className="text-sm font-medium leading-5 text-center">
                    News to be uploaded soon.
                  </h3>
                </li>
              )}
            </ul>
          </Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab.Group>
  );
};

export default HeadlessUITab;
